import React from "react";

const AppContext = React.createContext({
    translatedTexts: {},
    isLoading: true,
    setIsLoading: (isLoading: boolean) => {},
});

export default AppContext;
